import { createContext } from 'react'

export interface InboxLiveSync {
  // The row open in a detail panel, which live removal must never delete out
  // from under the reader. Imperative rather than a prop so a selection change
  // does not re-render the whole app under the coordinator.
  setProtectedItemId: (itemId: string | undefined) => void
  // Called when something outside the coordinator replaced the feed store
  // wholesale, with the time that finished, so a page it read earlier is not
  // applied on top of the fresher result.
  markStoreReplaced: (at: number) => void
}

// Inert by default, so a tree without the coordinator — a test, a story —
// behaves exactly as it did before cross-tab sync existed.
export const InboxLiveSyncContext = createContext<InboxLiveSync>({
  setProtectedItemId: () => {},
  markStoreReplaced: () => {},
})
